// extracted by mini-css-extract-plugin
export default {"innerItemWrapper":"BankStatementDetails_innerItemWrapper__s5lOe","downloadButtonsWrapper":"BankStatementDetails_downloadButtonsWrapper__a1oa9"};